import { render, staticRenderFns } from "./EditorFluxo.vue?vue&type=template&id=2bed4ab2&"
import script from "./EditorFluxo.vue?vue&type=script&lang=js&"
export * from "./EditorFluxo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports